module.exports = __webpack_public_path__ + "static/p9-a8468e58b3739a1b06be04ef430c1b92.jpg";